import { useSmsNotificationPausePreference } from './use-sms-notification-pause-preference';

export const useNotificationPreferences = () => {
  useSmsNotificationPausePreference();
};
